<div class="category-message-wrapper"><p class="category-message">{{ $t(message) }}</p></div>